import { Treasury } from 'common/models/treasury';
import { navigate } from 'gatsby';
import useParsedQueryString from 'hooks/useParsedQueryString';
import qs from 'qs';
import Tabs, { TabPane } from 'rc-tabs';
import React from 'react';
import Mint from '../Mint/Mint';
import Redeem from '../Redeem/Redeem';

enum TabName {
  MINT = 'Mint',
  REDEEM = 'Redeem',
}

enum TabKey {
  MINT = 'mint',
  REDEEM = 'redeem',
}

type Props = {
  treasuries: Treasury[];
  isLoadingTreasuries: boolean;
};

const MintRedeem: React.FC<Props> = (props) => {
  const {
    tab: urlTab,
    name: urlName,
    collateral: urlCollateral,
  } = useParsedQueryString();
  const [selectedTab] = React.useState(
    urlTab === TabKey.REDEEM ? TabKey.REDEEM : TabKey.MINT
  );

  const onChangeTab = (key: TabKey) => {
    if (key === TabKey.REDEEM) {
      // If redeem specify tab name in the url
      const urlQuery = qs.stringify({
        tab: key,
        name: urlName,
      });
      void navigate(`/mint?${urlQuery}`);
    } else {
      // if Mint don't specify tab name, it's already default per above
      const urlQuery = qs.stringify({
        name: urlName,
        collateral: urlCollateral,
      });
      void navigate(`/mint?${urlQuery}`);
    }
    // setSelectedTab(key);
  };

  return (
    <div className="inner-box mint-redeem-box tabs-container">
      <Tabs
        defaultActiveKey={selectedTab}
        onChange={(key) => onChangeTab(key as TabKey)}
        className="mt-11"
      >
        <TabPane key={TabKey.MINT} tab={TabName.MINT}>
          <Mint
            treasuries={props.treasuries}
            isLoadingTreasuries={props.isLoadingTreasuries}
          />
        </TabPane>
        <TabPane key={TabKey.REDEEM} tab={TabName.REDEEM}>
          <Redeem
            treasuries={props.treasuries}
            isLoadingTreasuries={props.isLoadingTreasuries}
          />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default MintRedeem;
